<script>
    // Adds all necessary stuff for you.
    import CyclicCandle from './primitives/cyclic_candle.js'
    import MMPrice from './primitives/mm_price.js'
    import { Overlay, layout_cnv } from '../../'

export default {
    name: 'TC',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'mano',
                version: '1.0.0',
                preset: {
                    name: 'TimeCycle, $showCycleHigh $showCycleLow',
                    side: 'onchart',
                    settings: {
                        "showCycleHigh": this.showCycleHigh,
                        "showCycleLow": this.showCycleLow,
                        "showPendingCycleHigh": this.showPendingCycleHigh,
                        "showPendingCycleLow": this.showPendingCycleLow
                    }
                }
            }
        },
        // Here goes your code. You are provided with:
        // { All stuff is reactive }
        // $props.layout -> positions of all chart elements +
        //  some helper functions (see layout_fn.js)
        // $props.interval -> candlestick time interval
        // $props.sub -> current subset of candlestick data
        // $props.data -> your indicator's data subset.
        //  Comes "as is", should have the following format:
        //  [[<timestamp>, ... ], ... ]
        // $props.colors -> colors (see TradingVue.vue)
        // $props.cursor -> current position of crosshair
        // $props.settings -> indicator custom settings
        //  E.g. colors, line thickness, etc. You define it.
        // ~
        // Finally, let's make the canvas dirty!
        draw(ctx) {
            let high = 0
            let low = 0
            let highIdx = 0
            let lowIdx = 0
            let blue = "#0096FF"
            let yellow = "#FDDA0D"
            let gray = "#f4f4f4"
            let darkgray = "#dfdfdf"
            let fill = "#0000ff"
            let fillOpacity = 0.1
            let strokeOpacity = 0.5
            let layout = this.$props.layout
            ctx.lineWidth = 1
            ctx.strokeWidth = 1
            ctx.strokeStyle = 'black'

            const globalCompositeOperation = ctx.globalCompositeOperation
            const globalAlpha = ctx.globalAlpha

            let canvasGradient = null
            let canvasClip = false

            let full_candles = this.$props.layout.full_candles
            for (var i = 0; i < full_candles.length; i++) {
                var candle = full_candles[i]
                if (candle.raw[2] > high) {
                    high = candle.raw[2]
                    highIdx = i
                }
                if (candle.raw[3] < low) {
                    low = candle.raw[3]
                    lowIdx = i
                }
            }

            if (this.showCycleHigh) {
                ctx.beginPath()

                for (var i = highIdx; i < full_candles.length; ) {
                    full_candles[i].cyclicHigh = true
                    var candle = full_candles[i]
                    var next_candle = i+120 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+120]
                    var next_candle_2 = i+240 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+240]

                    // Draw Blue Area
                    ctx.fillStyle = this.hexToRGBA(blue, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(blue, strokeOpacity)
                    ctx.rect(layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[3]), layout.t2screen(next_candle.raw[0]) - layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[2]) - layout.$2screen(candle.raw[3]))
                    ctx.moveTo(layout.t2screen(next_candle.raw[0]), layout.$2screen(next_candle.raw[2]))
                    ctx.lineTo(layout.t2screen(next_candle.raw[0]), layout.$2screen(candle.raw[2]))
                    ctx.fill()
                    ctx.stroke()

                    new CyclicCandle(this, ctx, layout, candle, candle.raw[4])
                    i+=120
                }
                ctx.closePath()
            }

            if (this.showPendingCycleHigh) {
                ctx.beginPath()
                for (var i = highIdx; i < full_candles.length; ) {
                    var candle = full_candles[i]
                    var next_candle = i+120 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+120]
                    var next_candle_2 = i+240 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+240]

                    // Draw Gray Area
                    ctx.fillStyle = this.hexToRGBA(gray, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(darkgray, strokeOpacity)
                    ctx.setLineDash([2,2])
                    ctx.rect(layout.t2screen(next_candle.raw[0]), layout.$2screen(candle.raw[3]), layout.t2screen(next_candle_2.raw[0]) - layout.t2screen(next_candle.raw[0]), layout.$2screen(candle.raw[2]) - layout.$2screen(candle.raw[3]))
                    ctx.fill()
                    ctx.stroke()

                    i+=120
                }
                ctx.closePath()
            }

            if (this.showCycleLow) {
                ctx.beginPath()
                for (var i = lowIdx; i < full_candles.length; ) {
                    full_candles[i].cyclicLow = true
                    var candle = full_candles[i]
                    var next_candle = i+120 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+120]

                    // Draw yellow Area
                    ctx.fillStyle = this.hexToRGBA(yellow, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(yellow, strokeOpacity)
                    ctx.rect(layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[3]), layout.t2screen(next_candle.raw[0]) - layout.t2screen(candle.raw[0]), layout.$2screen(candle.raw[2]) - layout.$2screen(candle.raw[3]))
                    ctx.moveTo(layout.t2screen(next_candle.raw[0]), layout.$2screen(next_candle.raw[2]))
                    ctx.lineTo(layout.t2screen(next_candle.raw[0]), layout.$2screen(candle.raw[2]))
                    ctx.fill()
                    ctx.stroke()

                    new CyclicCandle(this, ctx, layout, candle, candle.raw[4])
                    i+=120
                }
                ctx.closePath()
            }

            if (this.showPendingCycleLow) {
                ctx.beginPath()
                for (var i = lowIdx; i < full_candles.length; ) {
                    var candle = full_candles[i]
                    var next_candle = i+120 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+120]
                    var next_candle_2 = i+240 >= full_candles.length ? full_candles[full_candles.length - 1] : full_candles[i+240]

                    // Draw Gray Area
                    ctx.fillStyle = this.hexToRGBA(gray, fillOpacity)
                    ctx.strokeStyle = this.hexToRGBA(darkgray, strokeOpacity)
                    ctx.rect(layout.t2screen(next_candle.raw[0]), layout.$2screen(candle.raw[3]), layout.t2screen(next_candle_2.raw[0]) - layout.t2screen(next_candle.raw[0]), layout.$2screen(candle.raw[2]) - layout.$2screen(candle.raw[3]))
                    ctx.fill()
                    ctx.stroke()

                    i+=120
                }
                ctx.closePath()
            }

            //if (this.price_line) this.price.draw(ctx)
        },
        // For all data with these types overlay will be
        // added to the renderer list. And '$props.data'
        // will have the corresponding values. If you want to
        // redefine the default behviour for a prticular
        // indicator (let's say EMA),
        // just create a new overlay with the same type:
        // e.g. use_for() { return ['EMA'] }.
        use_for() {
            return ['TC']
        },
        data_colors() {
            return ['yellow']
        },
        mousemove(e) {
            const l = this.$props.layout
            const c = {
                x: l.width / 2,
                y: l.height / 2
            }
            if (
                (c.x - e.clientX) * (c.x - e.clientX) +
                (c.y - e.clientY) * (c.y - e.clientY) <
                42 * 42
            ) {
                this.woo = true
            } else {
                this.woo = false
            }
        },
        hexToRGBA(inputHex, opacity) {
            const hex = inputHex.replace("#", "")
            if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {

                const multiplier = (hex.length === 3) ? 1 : 2

                const r = parseInt(hex.substring(0, 1 * multiplier), 16)
                const g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16)
                const b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16)

                const result = `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`

                return result
            }
            return inputHex
        },
    },
    data() {
        // Define internal setting & constants here
        return {
            woo: false
        }
    }
}
</script>